import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { Lead } from "../../dtos/lead.viewmodel";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { MarketingService } from "./../../services/marketing/marketing.service";
import { ProjectsService } from "./../../services/projects/projects.service";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { OcrService } from "../../services/ocr/ocr.service";
import { OcrRecord } from "../../models/ocr.model";

@Component({
  selector: "addlead",
  templateUrl: "./addlead.component.html",
  styleUrls: ["./addlead.component.css"],
  providers: [LeadsService],
})
export class AddLeadComponent {
  title = "addlead";

  lead: any = null;

  ocrMessage: string = null;
  ocrUncertainFields: string[] = [];
  leadSources: Array<any> = [];
  agents: any;
  brokers: Array<any> = [];
  ambassadors: Array<any> = [];
  leadId;
  leadDetails = [];
  private sub: any;
  genderId: any;
  genders: Array<any> = [{ text: "Male" }, { text: "Female" }];
  roleId;
  role: any;
  data: Array<any> = [];
  currentEmailValid = true;
  errortext: boolean;
  userData: any;
  defineRule: any;
  channels: any[];
  channel: any;
  projects: any;
  types: any;
  channelview: any;

  disable_submit_button = false;

  arrSearch: any = [];
  dataFromSearch: any;

  selectedCar: number;

  cars = [
    { id: 1, name: "Volvo" },
    { id: 2, name: "Saab" },
    { id: 3, name: "Opel" },
    { id: 4, name: "Audi" },
  ];

  id_types = ["passport", "id"];

  events: any = [];
  brokersList: any = [];
  incentive_users: any = [];
  selected_incentive_broker: any;
  has_invalid_lead : boolean = JSON.parse(localStorage.getItem("invalid_lead")) ? true : false;
  rotations: any[] = [];
  assign_type: "agent" | "rotation" = "agent";

  private hasDuplicateFlag(response: any): boolean {
    if (!response) {
      return false;
    }

    const duplicateKeys = [
      "is_duplicate",
      "is_duplicated",
      "duplicate",
      "duplicated",
      "has_duplicate",
      "duplicate_lead",
      "is_duplicate_lead",
      "lead_is_duplicate",
    ];
    const duplicateMessagePattern = /duplicat|duplicate lead|-|-/i;

    const stack = [response];
    const visited = [];

    while (stack.length) {
      const current = stack.pop();
      if (!current) {
        continue;
      }

      if (Array.isArray(current)) {
        current.forEach((item) => stack.push(item));
        continue;
      }

      if (typeof current !== "object") {
        continue;
      }

      if (visited.indexOf(current) !== -1) {
        continue;
      }
      visited.push(current);

      for (const key of duplicateKeys) {
        const duplicateFlag = current[key];
        if (
          duplicateFlag === true ||
          duplicateFlag === 1 ||
          duplicateFlag === "1" ||
          (typeof duplicateFlag === "string" &&
            duplicateFlag.toLowerCase() === "true")
        ) {
          return true;
        }
      }

      const possibleMessage =
        current.message || current.error || current.msg || current.detail;
      if (
        typeof possibleMessage === "string" &&
        duplicateMessagePattern.test(possibleMessage)
      ) {
        return true;
      }

      Object.keys(current).forEach((key) => {
        const value = current[key];
        if (value && typeof value === "object") {
          stack.push(value);
        }
      });
    }

    return false;
  }

  private normalizePhoneForMatching(phone: any): string {
    if (phone === null || phone === undefined) {
      return "";
    }
    return phone
      .toString()
      .trim()
      .replace(/[^0-9]/g, "");
  }

  private phonesMatch(left: any, right: any): boolean {
    const normalizedLeft = this.normalizePhoneForMatching(left);
    const normalizedRight = this.normalizePhoneForMatching(right);

    if (!normalizedLeft || !normalizedRight) {
      return false;
    }

    if (normalizedLeft === normalizedRight) {
      return true;
    }

    // Helps when one side has country code and the other side does not.
    return (
      normalizedLeft.length >= 8 &&
      normalizedRight.length >= 8 &&
      (normalizedLeft.endsWith(normalizedRight) ||
        normalizedRight.endsWith(normalizedLeft))
    );
  }

  private routeAfterSave(
    response: any,
    savedPhone: any,
    successMessage: string
  ) {
    const phone = (savedPhone || "").toString().trim();

    const goToDuplicateLeads = () => {
      this.slimLoadingBarService.complete();
      this.disable_submit_button = false;
      this.router.navigate(["/pages/duplicated-leads"], {
        queryParams: phone ? { phone } : {},
      });
    };

    const goToLeads = () => {
      this.slimLoadingBarService.complete();
      swal("Woohoo!", successMessage, "success").then(() => {
        this.router.navigate(["pages/leads"]);
      });
      this.disable_submit_button = false;
    };

    if (this.hasDuplicateFlag(response)) {
      goToDuplicateLeads();
      return;
    }

    if (!phone) {
      goToLeads();
      return;
    }

    this.leadsService.getDuplicatedLeads({ phone, paginate: false }).subscribe(
      (duplicatesResponse: any) => {
        const duplicatedLeads =
          duplicatesResponse &&
          Array.isArray(duplicatesResponse.data)
          ? duplicatesResponse.data
          : Array.isArray(duplicatesResponse)
          ? duplicatesResponse
          : [];

        const foundInDuplicatedLeads = duplicatedLeads.some((duplicatedLead) =>
          this.phonesMatch(
            duplicatedLead && duplicatedLead.phone,
            phone
          ) ||
          this.phonesMatch(
            duplicatedLead &&
              duplicatedLead.lead &&
              duplicatedLead.lead.phone,
            phone
          )
        );

        if (foundInDuplicatedLeads) {
          goToDuplicateLeads();
          return;
        }

        goToLeads();
      },
      () => {
        // Safety-first fallback: avoid showing potential duplicates in regular leads.
        goToDuplicateLeads();
      }
    );
  }

  constructor(
    private leadsService: LeadsService,
    private route: ActivatedRoute,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private marketingService: MarketingService,
    private projectsService: ProjectsService,
    private userService: UserServiceService,
    public http: HttpClient,
    private reservationService: ReservationService
  ,
    private ocrService: OcrService
  ) {
    this.userData = JSON.parse(window.localStorage.getItem("userProfile"));
    this.lead = new Lead();
    this.lead.gender = "Male";
    this.leadSource();
    if (
      this.userData.role == "Admin" ||
      this.userData.role == "CFO" ||
      (this.userData.is_sales_team && this.userData.is_arm)
    ) {
      // this.getBrokers();
    }
  }

  ngOnInit() {
    // this.getBrokers();
    this.getBrokersList();
    this.getAmbassadors();
    this.getEvents();
    this.getAllRotations();
    this.getChannels();
    this.getProjects();
    this.getTypes();
    this.sub = this.route.params.subscribe((params) => {
      this.leadId = +params["id"]; // (+) converts string 'id' to a number
      if (this.leadId > 0) {
        this.getLeadDetails();
      } else {
        this.clearControls();
      }
    });

    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        console.log(data);
        console.log(this.lead.agent_id);
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getIncentiveUsers(broker_id: number) {
    this.incentive_users = [];
    this.lead.broker_incentive_id = "";
    this.userService.get_incentive_users(broker_id).subscribe(
      (res: any) => {
        this.incentive_users = res;
        console.log(this.agents);
        this.lead.broker_incentive_id = this.selected_incentive_broker;
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  ngOnDestroy() {
    localStorage.removeItem("invalid_lead");
  }


  receivePhone(event, obj, phone, code, err) {
    this[obj][err] = event.phoneError;
    this[obj][phone] = event.phone;
    this[obj][code] = event.code;
  }

  save() {
    if (!this.lead.name) {
      swal("Lead Name Required", "", "error");
      return;
    } else if (!this.lead.phone) {
      swal("Lead Phone Required", "", "error");
      return;
    }

    if (this.lead.phone_error) {
      swal("Invalid Primary Phone", this.lead.phone_error || "Please enter a valid phone number", "error");
      return;
    }

    if (this.lead.phone_2) {
      if (this.lead.phone_error) {
        swal("Invalid Secondary Phone", this.lead.phone_error || "Please enter a valid phone number", "error");
        return;
      }
    }

    if (this.lead.phone_3) {
      if (this.lead.phone_error) {
        swal("Invalid Third Phone", this.lead.phone_error || "Please enter a valid phone number", "error");
        return;
      }
    }

    if (this.assign_type == "agent" && !this.lead.agent_id) {
      swal("Agent Required", "", "error");
      return;
    }

    if (this.assign_type == "rotation" && !this.lead.rotation_id) {
      swal("Rotation Required", "", "error");
      return;
    }

    this.disable_submit_button = true;
    if (!this.lead.name || !this.lead.phone || !this.lead.lead_channel_id) {
      swal("Error", "Please fill all the required fields", "error");
      this.disable_submit_button = false;
      return;
    }
    this.slimLoadingBarService.start();
    this.errortext = null;

    const payload: any = {
      ...this.lead,
    };

    if (this.assign_type == "rotation") {
      payload.rotation_id =
        payload.rotation_id && payload.rotation_id.id
          ? payload.rotation_id.id
          : payload.rotation_id || "";
      payload.agent_id = "";
    } else {
      payload.agent_id =
        payload.agent_id && payload.agent_id != null
          ? payload.agent_id.id || payload.agent_id
          : "";
      payload.rotation_id = "";
    }

    if (JSON.parse(localStorage.getItem("invalid_lead"))) {
      this.leadId = null;
      delete payload.id;
      payload.invalid_lead_id = JSON.parse(localStorage.getItem("invalid_lead")).id
    }
    if (this.leadId) {
      // if (this.channel) {
      //   this.lead.lead_channel_id = this.channel;
      // }
      if (payload.lead_source) {
        this.disable_submit_button = true;
        this.leadsService.editALead(this.leadId, payload).subscribe(
          (data: any) => {
            console.log(data);
            this.routeAfterSave(data, payload.phone, "Lead updated succesfully!");
          },
          (err) => {
            if (this.hasDuplicateFlag(err)) {
              this.slimLoadingBarService.complete();
              this.disable_submit_button = false;
              this.router.navigate(["/pages/duplicated-leads"]);
              return;
            }
            this.errorHandlerService.handleErorr(err);
            this.errortext = err._body;
            this.slimLoadingBarService.complete();
            this.disable_submit_button = false;
            console.log(err);
            if (err.error.message == "Lead already exists with you") {
              if (!isNaN(err.error.leadId)) {
                this.router.navigate([`/pages/leads/${err.error.leadId}`]);
              }
            }
          }
        );
      } else {
        swal("Lead source is required", "", "error");
      }
    } else {
      // this.lead.lead_channel_id = this.channel;
      if (payload.lead_source) {
        this.disable_submit_button = true;
        this.leadsService.createLead(payload).subscribe(
          (data: any) => {
            console.log(data);
            this.routeAfterSave(data, payload.phone, "Lead created succesfully!");
          },
          (err) => {
            if (this.hasDuplicateFlag(err)) {
              this.slimLoadingBarService.complete();
              this.disable_submit_button = false;
              this.router.navigate(["/pages/duplicated-leads"]);
              return;
            }
            this.errortext = err._body;
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
            this.disable_submit_button = false;
            console.log(err);
            if (err.error.message == "Lead already exists with you") {
              if (!isNaN(err.error.leadId)) {
                this.router.navigate([`/pages/leads/${err.error.leadId}`]);
              }
            }
          }
        );
      } else {
        swal("Lead source is required", "", "error");
      }
    }
  }

  calculatesChannelAndSources(channel_id, leadSource) {
    console.log(channel_id, leadSource, this.channels);
    this.channel = channel_id;
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((channel) => {
          if (channel.id == channel_id) {
            this.leadSources = channel.sources;
          }
          this.lead.lead_source = leadSource;
        });
      });
    } else {
      this.channels.forEach((channel) => {
        if (channel.id == channel_id) {
          this.leadSources = channel.sources;
        }
        this.lead.lead_source = leadSource;
      });
    }
  }

  leadSource() {
    var data = this.leadsService.leadSource();
  }

  getLeadDetails() {
    if (this.lead.broker_id === null) {
      this.lead.broker_id = 1;
    }
    if (
      this.lead.lead_source === null ||
      this.lead.lead_source == "Self Generate"
    ) {
      this.lead.lead_source = "Self Generate";
    }
    if (this.lead.agent_id === null) {
      this.leadId.agent_id = 0;
    }
    this.slimLoadingBarService.start();
    this.leadsService.getLeadDetails(this.leadId).subscribe(
      (data: any) => {
        console.log(data);
        if (JSON.parse(localStorage.getItem("invalid_lead"))) {
          data.lead = JSON.parse(localStorage.getItem("invalid_lead"));
        }
        setTimeout(() => {
          if (this.lead.phone) {
            if (JSON.parse(localStorage.getItem("invalid_lead"))) {
              this.lead.phone_without_code = data.lead.phone;
            } else {
              this.lead.phone_without_code = data.lead.phone_without_code
            }
            console.log(this.lead.phone_without_code);
            this.lead.code = data.lead.code
          }
          if (this.lead.phone_2) {
            if (JSON.parse(localStorage.getItem("invalid_lead"))) {
              this.lead.phone_2_without_code = data.lead.phone_2;
            } else {
              this.lead.phone_2_without_code = data.lead.phone_2_without_code
            }
            this.lead.code_2 = data.lead.code_2
          }
          if (this.lead.phone_3) {
            if (JSON.parse(localStorage.getItem("invalid_lead"))) {
              this.lead.phone_3_without_code = data.lead.phone_3;
            } else {
              this.lead.phone_3_without_code = data.lead.phone_3_without_code
            }
            this.lead.code_3 = data.lead.code_3
          }
        }, 500);
        this.lead.name = data.lead.name;
        this.lead.phone = data.lead.phone;
        this.lead.email = data.lead.email;
        this.lead.gender = data.lead.gender;
        this.lead.occupation = data.lead.job_title;
        this.lead.workplace = data.lead.workplace;
        this.lead.intrestedProjects = data.lead.project_ids ;
        this.lead.intrestedUnitTypes = data.lead.intrestedUnitTypes;
        this.lead.budget_from = data.lead.budget_from;
        this.lead.budget_to = data.lead.budget_to;
        this.lead.lead_source = data.lead.lead_source;
        this.lead.agent_id = data.lead.agent;
        this.lead.rotation_id =
          data.lead.rotation_id ||
          (data.lead.rotation && data.lead.rotation.id) ||
          null;
        this.assign_type = this.lead.rotation_id ? "rotation" : "agent";
        this.lead.id_address = data.lead.id_address;
        // this.lead.agent_id = data.lead.agent_id;
        this.lead.date_of_birth = data.lead.date_of_birth;
        this.lead.national_issue_date = data.lead.national_issue_date;
        this.lead.fax_num = data.lead.fax_num;
        this.lead.address = data.lead.address;
        this.lead.issued_by = data.lead.issued_by;
        this.lead.comment = data.lead.comment;
        this.lead.lead_channel_id = data.lead.lead_channel_id;
        this.lead.phone_2 = data.lead.phone_2;
        this.lead.phone_3 = data.lead.phone_3;
        this.lead.ambassador_id = data.lead.ambassador_id;
        this.lead.broker_id = data.lead.broker_id;
        this.lead.lead_event_id = data.lead.lead_event_id;
        this.lead.nationality = data.lead.nationality;
        this.lead.id_type = data.lead.id_type;
        this.lead.id_number = data.lead.id_number;
        this.lead.lead_channel = data.lead.lead_channel;
        this.lead.lead_channel_id = data.lead.lead_channel.id;
        data.lead.broker_incentive && (this.selected_incentive_broker = data.lead.broker_incentive.id);
        if (this.lead.lead_source == "Broker") {
          this.getIncentiveUsers(this.lead.broker_id);
        }
        this.calculatesChannelAndSources(
          data.lead.lead_channel.id,
          data.lead.lead_source
        );
        if (this.lead.intrestedProjects == null) {
          this.lead.intrestedProjects = "All";
        }
        this.slimLoadingBarService.complete();
        this.getBrokers();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getGenders() {
    this.genders = null;
    this.genders = this.leadsService.getGenders();
  }

  clearControls() {
    this.lead = new Lead();
    this.lead.lead_source = "Self Generate";
    this.lead.gender = "Male";
    this.lead.agent_id = null;
    this.lead.rotation_id = null;
    this.assign_type = "agent";
    console.log("lead_source", this.lead.lead_source);
  }

  cancel() {}

  gotodashboard() {
    this.router.navigate(["/pages/leads"]);
  }
  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        if (
          this.userData.is_sales_team ||
          this.userData.role == "Call Center"
        ) {
          this.channel = 1;
          this.channelChange(1);
        }
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  channelChange(event, change = true) {
    console.log("change", event.target.value);
    if (change) {
      this.lead.lead_source = null;
    }
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((e) => {
          if (e.id == this.lead.lead_channel.id) {
            this.leadSources = [];
            if (change) {
              this.lead.lead_source = null;
            }
            this.leadSources = e.sources;
            this.channelview = e.name;
            if (change && this.channelview != "Brokers") {
              if (this.lead.broker_id) {
                this.lead.broker_id = null;
              } else if (this.lead.ambassador_id) {
                this.lead.ambassador_id = null;
              }
            }
          }
        });
      });
    } else {
      this.channels.forEach((e) => {
        if (e.id == this.lead.lead_channel_id) {
          this.leadSources = [];
          if (change) {
            this.lead.lead_source = null;
          }
          this.leadSources = e.sources;
          this.channelview = e.name;
          if (change && this.channelview != "Brokers") {
            if (this.lead.broker_id) {
              this.lead.broker_id = null;
            } else if (this.lead.ambassador_id) {
              this.lead.ambassador_id = null;
            }
          }
        }
      });
    }
  }

  getProjects() {
    this.projectsService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        this.projects = data;
        console.log(this.projects);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getAllRotations() {
    this.marketingService.getAllRotations().subscribe(
      (data: any) => {
        this.rotations = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getTypes() {
    this.projectsService.getUnitTypes().subscribe((data: any) => {
      this.types = data;
    });
  }

  getBrokers() {
    let params: any = {};
    console.log(this.lead.agent_id);
    if (this.userData.role != "Property Consultant") {
      if (!this.lead.agent_id || this.lead.agent_id === null) {
        this.brokers = [];
        return;
      }
      params.user_id = this.lead.agent_id.id || this.lead.agent_id;
    }

    this.slimLoadingBarService.start();
    this.userService.getBorkersByUser(params).subscribe(
      (data: any) => {
        this.brokers = data;
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokersList() {
    let params: any = {};
    params.is_select_form = true;
    this.slimLoadingBarService.start();
    this.userService.getBorkers(params).subscribe(
      (data: any) => {
        this.brokersList = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getAmbassadors() {
    let params = {
      paginate: false,
    };
    this.slimLoadingBarService.start();
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  checkPhoneValid(event: any) {
    const pattren = /[0-9\+]/;
    console.log(event.keyCode);
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattren.test(inputChar)) {
      event.preventDefault();
    }
  }

  /*
   * Listen On Lead Source Select
   *
   * if select Broker -> Broker select will appear
   */
  changeLeadSource(ev) {
    console.log(ev);
    // if (ev == 'Broker') this.channelview = ev;
  }

  getEvents() {
    this.reservationService.getAllEvents().subscribe((res: any) => {
      this.events = res;
      console.log(res);
    });
  }

  /**
   * Fill the lead from a scanned national ID. This is a create form, so there
   * is nobody to look up - every readable field is written onto `lead`, which
   * the template binds with ngModel.
   *
   * Two translations are needed. The date inputs are native type="date" and
   * type="month", so the pipeline's ISO values fit directly (the month input
   * just needs truncating). Gender does not: the <select> options are "Male"
   * and "Female" while the pipeline returns "male", so it is capitalised or
   * the control silently shows nothing.
   */
  onIdScanned(record: OcrRecord): void {
    const uncertain: string[] = [];
    const self = this;

    const set = function (property: string, identityKey: string, transform?: any) {
      const raw = self.ocrService.identityValue(record, identityKey);
      if (raw === null) {
        return;
      }
      const value = transform ? transform(raw) : raw;
      if (value === null || value === "") {
        return;
      }
      self.lead[property] = value;
      if (self.ocrService.needsVerification(record, identityKey)) {
        uncertain.push(property);
      }
    };

    set("id_number", "national_number", function (raw) {
      const digits = raw.replace(/\D/g, "");
      return digits ? digits : null;
    });
    set("date_of_birth", "birth_date");
    set("national_issue_date", "id_issue_date", function (raw) {
      return /^\d{4}-\d{2}/.test(raw) ? raw.substring(0, 7) : null;
    });
    set("address", "address_ar");
    set("id_address", "address_ar");
    set("occupation", "occupation_ar");
    set("district", "governorate");
    set("gender", "gender", function (raw) {
      return raw.charAt(0).toUpperCase() + raw.substring(1).toLowerCase();
    });

    this.ocrUncertainFields = uncertain;

    const critical = this.ocrService.criticalFlags(record);
    this.ocrMessage = critical.length
      ? "This scan did not verify: " + critical[0] + " Check the fields against the card."
      : null;
  }

  onIdScanCleared(): void {
    this.ocrMessage = null;
    this.ocrUncertainFields = [];
  }

  isOcrUncertain(property: string): boolean {
    return this.ocrUncertainFields.indexOf(property) !== -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/lead/addLead/addlead.component.ts